import { isAfter, isBefore, isFuture, isPast } from '@fora-monorepo/date-utils';

import { FAGroupViewModel, Markup, MarkupNew } from '../../types';

export const getPreviousAndFutureMarkupsOld = (markups: Markup[]) => {
  const futureMarkups = markups
    .filter(markup => isFuture(markup.startDate))
    .sort((a, b) => (isAfter(b.startDate, a.startDate) ? -1 : 1));
  const previousMarkups = markups
    .filter(markup => markup.endDate && isPast(markup.endDate))
    .sort((a, b) => (isBefore(b.startDate, a.startDate) ? -1 : 1));

  return { previousMarkups, futureMarkups };
};
export const getPreviousAndFutureMarkups = (markups: MarkupNew[]) => {
  const futureMarkups = markups
    .filter(markup => isFuture(markup.startDate))
    .sort((a, b) => (isAfter(b.startDate, a.startDate) ? -1 : 1));
  const previousMarkups = markups
    .filter(markup => markup.endDate && isPast(markup.endDate))
    .sort((a, b) => (isBefore(b.startDate, a.startDate) ? -1 : 1));

  return { previousMarkups, futureMarkups };
};

export const getExpiredAndCurrentFAGroups = (faGroups: FAGroupViewModel[]) => {
  const currentFAGroups: FAGroupViewModel[] = [];
  const expiredFAGroups: FAGroupViewModel[] = [];

  faGroups.forEach(faGroup => {
    if (!faGroup.validTo || isFuture(faGroup.validTo)) {
      currentFAGroups.push(faGroup);
    }
    if (faGroup.validTo && isPast(faGroup.validTo)) {
      expiredFAGroups.push(faGroup);
    }
  });

  currentFAGroups.sort((a, b) => (isAfter(a.validFrom, b.validFrom) ? -1 : 1));
  expiredFAGroups.sort((a, b) => (isBefore(b.validFrom, a.validFrom) ? -1 : 1));

  return { expiredFAGroups, currentFAGroups };
};
